import request from "../Requests/requests";
import { loadTimeAllTodos } from "../store/timeAllTodosReducer";
import getDateUTC from "../utils/getDateUTC";

export const getTimeAllTodos = () => {
    return async dispatch => {
        try {
            const response = await request.get('/Time/', { params: { date: getDateUTC(), userId: localStorage.getItem('userID') } });
            const data = response.data;
            dispatch(loadTimeAllTodos(data));
            return data;
          } catch (error) {
            throw error;
          }
        }
    }